import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/axiosInstance";
import endpoints from "../../../api/endpoints";

export interface Objectif {
  id: number;
  userName: string;
  montant: number;
  periode: string;
  periodeString: string;
  realisation: number;
  mois: number;
  annee: number;
}

export interface Representant {
    userId: string;
  username: string;
}

interface ObjectifsState {
  objectifs: Objectif[];
  representants: Representant[];
  loading: boolean;
  error: string | null;
}

const initialState: ObjectifsState = {
  objectifs: [],
  representants: [],
  loading: false,
  error: null,
};

export const fetchObjectifs = createAsyncThunk(
  "objectifs/fetchObjectifs",
  async () => {
    const response = await axiosInstance.get(endpoints.objectif.getObjectives);
    return response.data.data as Objectif[];
  }
);

export const deleteObjectif = createAsyncThunk(
  "objectifs/deleteObjectif",
  async (id: number) => {
    const response = await axiosInstance.get(`${endpoints.objectif.deleteObjectif}/${id}`);
    return id;
  }
);

export const fetchRepresentants = createAsyncThunk(
  "objectifs/fetchRepresentants",
  async () => {
    const response = await axiosInstance.get(endpoints.objectif.listRepresentants);
    return response.data.data as Representant[];
  }
);

export const createObjectif = createAsyncThunk(
  "objectifs/createObjectif",
  async (objectif: { commercialId: string; mois: number; annee: number; montant: number }) => {
    const response = await axiosInstance.post(endpoints.objectif.createObjectif, objectif);
    return response.data.data as Objectif;
  }
);

const objectifsSlice = createSlice({
  name: "objectifs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchObjectifs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchObjectifs.fulfilled,
        (state, action: PayloadAction<Objectif[]>) => {
          state.loading = false;
          state.objectifs = action.payload;
        }
      )
      .addCase(fetchObjectifs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      })
      .addCase(deleteObjectif.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteObjectif.fulfilled, (state, action: PayloadAction<number>) => {
        state.loading = false;
        state.objectifs = state.objectifs.filter(objectif => objectif.id !== action.payload);
      })
      .addCase(deleteObjectif.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      })
      .addCase(fetchRepresentants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchRepresentants.fulfilled,
        (state, action: PayloadAction<Representant[]>) => {
          state.loading = false;
          state.representants = action.payload;
        }
      )
      .addCase(fetchRepresentants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      })
      .addCase(createObjectif.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createObjectif.fulfilled,
        (state, action: PayloadAction<Objectif>) => {
          state.loading = false;
          state.objectifs.push(action.payload);
        }
      )
      .addCase(createObjectif.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export default objectifsSlice.reducer;
